// Angular imports
import { Component, OnInit } from '@angular/core';

// CC-Common imports
import { IconConstants, Utils } from 'cc-common';

// Service imports
import { HelperService } from '../../../_services/shared-services/helper.service';

@Component({
    selector: 'app-contact-page',
    templateUrl: './contact-page.component.html',
    styleUrls: ['./contact-page.component.scss']
})
export class ContactPageComponent implements OnInit {
    isTicketHelpModalVisible = false;
    showPopOver = false;
    isPopoverVisible = false;
    activePopoverTarget: string;
    activePopoverData: any;

    iconCancel = IconConstants.CANCEL;
    iconStar = IconConstants.STAR;
    popoverData: { id: string; title: string; description: string; items: string[] }[];

    constructor(private readonly helperService: HelperService) {}

    ngOnInit(): void {
        this.preparePopOverData();
    }

    onShown(e: any): void {
        e.component.repaint();
    }

    onTileClick(issueType: string): void {
        if (Utils.notNullOrEmpty(issueType)) {
            if (Utils.equalsIgnoreCase(issueType, 'TI')) {
                this.helperService.openWindow(
                    'https://ciracloud.atlassian.net/servicedesk/customer/portal/5/group/20/create/64',
                    '_blank',
                    null,
                    null
                );
            }
            if (Utils.equalsIgnoreCase(issueType, 'AI')) {
                this.helperService.openWindow(
                    'https://ciracloud.atlassian.net/servicedesk/customer/portal/5/group/20/create/69',
                    '_blank',
                    null,
                    null
                );
            }
            if (Utils.equalsIgnoreCase(issueType, 'T')) {
                this.helperService.openWindow(
                    'https://ciracloud.atlassian.net/servicedesk/customer/portal/5/group/51/create/66',
                    '_blank',
                    null,
                    null
                );
            }
            if (Utils.equalsIgnoreCase(issueType, 'C')) {
                this.helperService.openWindow(
                    'https://ciracloud.atlassian.net/servicedesk/customer/portal/5/group/51/create/68',
                    '_blank',
                    null,
                    null
                );
            }
        }
    }

    viewOpenTickets(): void {
        this.helperService.openWindow(
            'https://ciracloud.atlassian.net/servicedesk/customer/user/requests?page=1&sortBy=createdDate&sortOrder=DESC&statuses=open%27',
            '_blank',
            null,
            null
        );
    }

    onTileHover(targetId: string, visible: boolean): void {
        const popoverData = this.popoverData.find((item) => Utils.equalsIgnoreCase(item.id, targetId));
        if (Utils.notNullAndDefined(popoverData)) {
            this.activePopoverTarget = targetId;
            this.activePopoverData = popoverData;
            this.isPopoverVisible = visible;
        }
    }

    preparePopOverData(): void {
        this.popoverData = [
            {
                id: 'technicalIssueId',
                title: 'Technical Issue',
                description: 'Submit this form if you:',
                items: [
                    'Received an error message',
                    'Noticed a display issue',
                    'Have an issue with a batch job or system process',
                    'Any other technical issue with CiraNet'
                ]
            },
            {
                id: 'accessIssueId',
                title: 'Access Issue',
                description: 'Submit this form when:',
                items: [
                    'You or a team member cannot access something you need',
                    'You or someone you’re helping is having a password issue',
                    'A board member needs help accessing the portal'
                ]
            },
            {
                id: 'templateIssueId',
                title: 'Template',
                description: 'Submit this form if you need a:',
                items: ['Custom response template', 'Quick response template', 'Violation template']
            },
            {
                id: 'configurationIssueId',
                title: 'Configuration',
                description: 'Submit this form if you:',
                items: ['Need help with a change in configuration']
            }
        ];
    }
}
